var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-product-room-scene-colors-wrapper" }, [
    _c(
      "div",
      { staticClass: "wf-product-room-scene-colors-container container-fluid" },
      [
        _c("div", { staticClass: "wf-product-room-scene-colors" }, [
          _c(
            "ul",
            {
              class: [
                "wf-product-room-scene-colors-list position-relative",
                { "scroll-fade-bottom": !_vm.isDyelotPopupShowing }
              ]
            },
            _vm._l(_vm.colors, function(color, index) {
              return _c(
                "li",
                {
                  key: color.colorNumber + "-" + color.colorName,
                  staticClass: "wf-product-room-scene-color-item pdp-color-item"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn wf-product-room-scene-color-item-button",
                      class:
                        color.colorNumber === _vm.selectedColor.colorNumber
                          ? "wf-product-room-scene-color-item-button-active"
                          : "wf-product-room-scene-color-item-button-disabled",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.updateColor(color)
                        }
                      }
                    },
                    [
                      _c("img", {
                        class:
                          color.colorNumber === _vm.selectedColor.colorNumber
                            ? "color-item-button-active"
                            : "color-item-button-inactive",
                        attrs: {
                          src: _vm.$helpers.getColorThumbnailImageUrl(
                            _vm.sellingStyleNumber,
                            color.colorNumber
                          ),
                          alt: "img"
                        },
                        on: { error: _vm.handleImageError }
                      }),
                      _vm._v(" "),
                      color.customPdqAvailable == true
                        ? _c("div", { staticClass: "pdp-pdq-overlay" }, [
                            _c("span", {
                              staticClass:
                                "pdqLogo png-icon png-icon-icons-symbols--ko-txtpdq"
                            })
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "wf-product-room-scene-color-item-name d-none d-lg-block mt-1 mb-1"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            color.colorName +
                              (color.customIsDisclaimerColor ? "*" : "")
                          ) +
                          "\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(color.colorNumber) +
                          "\n            "
                      ),
                      color.realTimeInventory &&
                      color.realTimeInventory.availableRtlQty > 0 &&
                      !_vm.isComingSoonProduct
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "instock-available text-success text-capitalize"
                            },
                            [
                              _vm._l(_vm.productData.colors, function(
                                color,
                                indexInner
                              ) {
                                return _c("div", [
                                  indexInner === index
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-uppercase cursor-pointer",
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleDyelotPopup(
                                                indexInner
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.Label.DyelotAvailability"
                                                ]
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showDyelotPopup[indexInner] &&
                                  indexInner === index
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _c("pc-product-dyelots-popup", {
                                            attrs: {
                                              showPopup:
                                                _vm.showDyelotPopup[indexInner],
                                              dyelotObjects: color.dyeLotInfo
                                            },
                                            on: {
                                              close: function($event) {
                                                return _vm.toggleDyelotPopup(
                                                  indexInner
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    color.realTimeInventory.availableRtlQtyUom
                                  ) +
                                  "\n              " +
                                  _vm._s(
                                    _vm.$resourceString["generic.product.avail"]
                                  ) +
                                  "\n            "
                              )
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br")
                    ]
                  ),
                  _vm._v(" "),
                  color.customIsDisclaimerColor &&
                  color.colorNumber == _vm.selectedColor.colorNumber
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "position-absolute color-disclaimer-message small text-muted"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$resourceString["pdp.color.disclaimer"]
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.selectedColorIndex !== null
            ? _c("div", { staticClass: "color-details" }, [
                _vm.colors[_vm.selectedColorIndex]
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "wf-product-room-scene-color-item-name d-lg-none"
                        },
                        [
                          _c("span", { staticClass: "font-weight-normal" }, [
                            _vm._v(
                              _vm._s(
                                _vm.colors[_vm.selectedColorIndex].colorName +
                                  (_vm.colors[_vm.selectedColorIndex]
                                    .customIsDisclaimerColor
                                    ? "*"
                                    : "")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3 mr-3" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.colors[_vm.selectedColorIndex].colorNumber
                                ) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.colors[_vm.selectedColorIndex]
                            .realTimeInventory &&
                          _vm.colors[_vm.selectedColorIndex].realTimeInventory
                            .availableRtlQty > 0 &&
                          !_vm.isComingSoonProduct
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "instock-available text-success text-capitalize mb-2"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "instock-available text-capitalize text-success"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.colors[_vm.selectedColorIndex]
                                              .realTimeInventory
                                              .availableRtlQtyUom
                                          ) +
                                          "\n\n                " +
                                          _vm._s(
                                            _vm.$resourceString[
                                              "generic.product.instockavailable"
                                            ]
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.productData.colors, function(
                                    color,
                                    indexInner
                                  ) {
                                    return _c(
                                      "div",
                                      { key: "popup-" + color.colorNumber },
                                      [
                                        indexInner === _vm.selectedColorIndex
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "text-uppercase cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleDyelotPopup(
                                                      indexInner
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$resourceString[
                                                        "product.Details.Label.DyelotAvailability"
                                                      ]
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showDyelotPopup[indexInner]
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _c("pc-product-dyelots-popup", {
                                                  attrs: {
                                                    showPopup:
                                                      _vm.showDyelotPopup[
                                                        indexInner
                                                      ],
                                                    dyelotObjects:
                                                      color.dyeLotInfo
                                                  },
                                                  on: {
                                                    close: function($event) {
                                                      return _vm.toggleDyelotPopup(
                                                        indexInner
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }